import {changePassword, deactivateAccount, AuthSnapshot} from '../../auth.js';
import {escapeHtml, renderLayout} from '../../layout.js';

/**
 * 账号安全页：修改密码与注销账号。
 */
export async function renderOrganizationPage(root: HTMLElement, auth: AuthSnapshot): Promise<void> {
  renderLayout(root, auth, '<div class="organization-page"><section class="organization-loading">正在加载…</section></div>');
  const host = root.querySelector<HTMLElement>('.organization-page');
  if (!host) return;
  try {
    host.innerHTML = `<section class="security-group"><form id="settingsPasswordForm" class="security-form"><div class="security-row"><label for="currentPassword">当前密码</label><input id="currentPassword" type="password" name="currentPassword" autocomplete="current-password" required></div><div class="security-row"><label for="newPassword">新密码</label><input id="newPassword" type="password" name="newPassword" minlength="8" maxlength="128" autocomplete="new-password" required></div><div class="security-row"><label for="confirmPassword">确认新密码</label><input id="confirmPassword" type="password" name="confirmPassword" minlength="8" maxlength="128" autocomplete="new-password" required></div><div class="security-actions"><span class="security-message" id="settingsPasswordMessage" role="status"></span><button class="security-save" type="submit">修改密码</button></div></form></section><section class="security-group"><div class="security-deactivate"><strong>注销账号</strong><button class="security-deactivate-btn" id="settingsDeactivateButton" type="button">注销</button></div></section><div class="security-modal" id="settingsDeactivateModal" hidden><div class="security-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="settingsDeactivateTitle"><h2 id="settingsDeactivateTitle">注销当前账号？</h2><p>将立即退出，且无法再用此账号登录。</p><label class="security-modal-field" for="settingsDeactivatePassword">当前密码<input id="settingsDeactivatePassword" type="password" name="deactivatePassword" autocomplete="current-password" required></label><p class="security-modal-error" id="settingsDeactivateError" hidden></p><div class="security-modal-actions"><button class="security-modal-cancel" id="settingsDeactivateCancel" type="button">取消</button><button class="security-modal-confirm" id="settingsDeactivateConfirm" type="button">注销</button></div></div></div>`;

    const settingsPasswordForm = host.querySelector<HTMLFormElement>('#settingsPasswordForm');
    settingsPasswordForm?.addEventListener('submit', async event => {
      event.preventDefault();
      const data = new FormData(settingsPasswordForm);
      const message = host.querySelector<HTMLElement>('#settingsPasswordMessage');
      const button = settingsPasswordForm.querySelector<HTMLButtonElement>('button[type="submit"]');
      if (String(data.get('newPassword')) !== String(data.get('confirmPassword'))) {
        if (message) {
          message.classList.add('is-error');
          message.textContent = '两次输入的新密码不一致';
        }
        return;
      }
      try {
        if (button) button.disabled = true;
        if (message) {
          message.classList.remove('is-error');
          message.textContent = '';
        }
        await changePassword(String(data.get('currentPassword')), String(data.get('newPassword')));
        settingsPasswordForm.reset();
        if (message) message.textContent = '密码修改成功';
      } catch (error) {
        if (message) {
          message.classList.add('is-error');
          message.textContent = error instanceof Error ? error.message : String(error);
        }
      } finally {
        if (button) button.disabled = false;
      }
    });

    const modal = host.querySelector<HTMLElement>('#settingsDeactivateModal');
    const errorEl = host.querySelector<HTMLElement>('#settingsDeactivateError');
    const passwordInput = host.querySelector<HTMLInputElement>('#settingsDeactivatePassword');
    const confirmButton = host.querySelector<HTMLButtonElement>('#settingsDeactivateConfirm');
    /**
     * 打开或关闭注销确认层。
     * @param open 是否打开
     */
    const setModalOpen = (open: boolean): void => {
      if (!modal) return;
      modal.hidden = !open;
      if (passwordInput) passwordInput.value = '';
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (open) window.setTimeout(() => passwordInput?.focus(), 0);
    };
    host.querySelector<HTMLButtonElement>('#settingsDeactivateButton')?.addEventListener('click', () => setModalOpen(true));
    host.querySelector<HTMLButtonElement>('#settingsDeactivateCancel')?.addEventListener('click', () => setModalOpen(false));
    modal?.addEventListener('click', event => {
      if (event.target === modal) setModalOpen(false);
    });
    passwordInput?.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        confirmButton?.click();
      }
    });
    confirmButton?.addEventListener('click', async () => {
      const password = passwordInput?.value ?? '';
      if (!password.trim()) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = '请输入当前登录密码';
        }
        passwordInput?.focus();
        return;
      }
      try {
        confirmButton.disabled = true;
        await deactivateAccount(password);
        window.location.assign('/login?account-deactivated=1');
      } catch (error) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = error instanceof Error ? error.message : String(error);
        }
        passwordInput?.focus();
        passwordInput?.select();
      } finally {
        confirmButton.disabled = false;
      }
    });
  } catch (error) {
    host.innerHTML = `<section class="organization-loading is-error">加载失败：${escapeHtml(error instanceof Error ? error.message : String(error))}</section>`;
  }
}
